import React from "react";
import { NavLink } from "react-router-dom";
import {
  HiBolt, HiOutlineBolt,
  HiAdjustmentsHorizontal, HiOutlineAdjustmentsHorizontal,
  HiStar, HiOutlineStar,
  HiDocumentText, HiOutlineDocumentText,
  HiChartBarSquare, HiOutlineChartBarSquare,
  HiQuestionMarkCircle, HiOutlineQuestionMarkCircle,
} from "react-icons/hi2";
import { useUserDashboard } from "../../contexts/UserDashboardContext";

const BASE_SECTIONS = [
  { url: "/app",         name: "Dla Mnie", IconActive: HiBolt,                  IconInactive: HiOutlineBolt },
  { url: "/training",    name: "Trening",  IconActive: HiAdjustmentsHorizontal, IconInactive: HiOutlineAdjustmentsHorizontal },
  { url: "/start-exam",  name: "Arkusze",  IconActive: HiDocumentText,          IconInactive: HiOutlineDocumentText },
];

const PEWNIAKI_SECTION = { url: "/surefires",   name: "Pewniaki",    IconActive: HiStar,               IconInactive: HiOutlineStar };
const NIEPEWNIAKI_SECTION = { url: "/niepewniaki", name: "Niepewniaki", IconActive: HiStar, IconInactive: HiOutlineStar };
const POSTEPY_SECTION = { url: "/user-stats",   name: "Postępy",     IconActive: HiChartBarSquare,     IconInactive: HiOutlineChartBarSquare };

const Nav = () => {
  const { dashboardData } = useUserDashboard();
  const activeDomain = dashboardData?.account_status?.active_domain || "PP";
  const sections = [
    ...BASE_SECTIONS,
    activeDomain === "PR" ? NIEPEWNIAKI_SECTION : PEWNIAKI_SECTION,
    POSTEPY_SECTION,
  ];

  return (
    <div className="w-full h-16 xl:h-[clamp(2rem,10vh,3.9rem)] bg-transparent">
      <ul className="grid grid-cols-5 justify-items-center items-center h-full">
        {sections.map((section) => (
          <li key={section.url} className="w-full h-full">
            <NavLink
              to={section.url}
              className={({ isActive }) =>
                `flex flex-col justify-center items-center gap-0.5 w-full h-full rounded-lg transition-colors duration-200
                  ${isActive ? "text-[#233855]" : "text-gray-400 hover:text-gray-600"}`
              }
            >
              {({ isActive }) => {
                const Icon = isActive ? section.IconActive : section.IconInactive;
                return (
                  <>
                    <Icon className="w-6 h-6" />
                    <span className="text-xs font-semibold tracking-wide leading-none">
                      {section.name}
                    </span>
                  </>
                );
              }}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Nav;
